import { useCallback } from 'react';

import {
  IconButton,
  ReqsReviewFeatureIcon,
  Tooltip,
} from '@frontend/legacy-components';

type CreateRuleIconActionProps = {
  createRuleAction: () => void;
  onClose: () => void;
};

export const CreateRuleIconAction = ({
  createRuleAction,
  onClose,
}: CreateRuleIconActionProps) => {
  const handleCreateRule = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();
      createRuleAction();
      onClose();
    },
    [createRuleAction, onClose],
  );

  return (
    <Tooltip placement="top" label="Create rule">
      <IconButton
        aria-label="Create rule"
        color="interaction.main"
        onClick={handleCreateRule}
      >
        <ReqsReviewFeatureIcon />
      </IconButton>
    </Tooltip>
  );
};
